import { CommonServiceToken, IntakeSheetSession } from "../../../helpers/constant";
import { removeSessionStorage } from "../../../helpers/storage";
import { CURRENT_CONFIG } from "../../../helpers/Util";
import { fetchInstance } from "../../../helpers/interceptor";


export function GetSessionData() {
  let SessionData = sessionStorage.getItem("Data");
  SessionData = JSON.parse(SessionData);
  return SessionData;
}

export function GetTokenInfo() {
  let Token = sessionStorage.getItem("TokenInfo");
  Token = JSON.parse(Token);
  return Token;
}

// export async function GetValueForIntakeSheet(props, selectedData) {
//   let data = "";
//   let SessionData = GetSessionData();
//   let TokenInfo = GetTokenInfo();

//   let companyId = props.selectedRow.searchResult
//     ? props.selectedRow.searchResult.Patient.Account.ID
//     : props.selectedRow.data.Account.ID;

//   let doctorId = SessionData.Physician.ID;

//   let caseId = props.selectedRow.searchResult
//     ? props.selectedRow.searchResult.Patient.CaseID
//     : props.selectedRow.data.CaseID;

//   const requestBody = JSON.stringify({
//     CaseFormDataId: null,
//     CompanyId: companyId,
//     DoctorId: doctorId,
//     FormName: selectedData.selectedData[0].FormName,
//     FormId: selectedData.selectedData[0].FormId,
//     TemplateName: selectedData.selectedData[0].TemplateName,
//     EntityLevel: selectedData.selectedData[0].EntityLevel,
//     FormType: selectedData.selectedData[0].FormType,
//     IsFormCompleted: selectedData.selectedData[0].IsFormCompleted,
//     JsonData: selectedData.selectedData[0].JsonData,
//     CaseId: caseId,
//     UserId: SessionData.ID,
//   });

//   await fetch(props.BaseUrl + "GenericForm/GetCaseFormData", {
//     method: "post",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + TokenInfo.AccessToken,
//     },
//     body: requestBody,
//   })
//     .then((Response) => {
//       if (Response.status === 401) {
//         data = "";
//         return data;
//       }
//       return Response.json();
//     })
//     .then((result) => {
//       data = result;
//       return data;
//     });

//   return data;
// }

export async function GetValueForIntakeSheet(props, selectedData) {
  let data = "";
  let TokenInfo = GetTokenInfo();

  // ── Read IDs from props or fall back to tokenData ──
  const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || "{}");

  let companyId = props.selectedRow?.searchResult
    ? props.selectedRow.searchResult.Patient.Account.ID
    : props.selectedRow?.data?.Account?.ID || tokenData.companyId || tokenData.CompanyId || "";

  let caseId = props.selectedRow?.searchResult
    ? props.selectedRow.searchResult.Patient.CaseID
    : props.selectedRow?.data?.CaseID || tokenData.caseId || tokenData.CaseId || "";

  // ── doctorId: try SessionData first, fall back to tokenData ──
  let SessionData = GetSessionData();
  let doctorId = SessionData?.Physician?.ID
    || tokenData.doctorId
    || tokenData.DoctorId
    || tokenData.physicianId
    || "";

  let userId = SessionData?.ID || tokenData.userId || tokenData.UserId || "";

  const requestBody = JSON.stringify({
    CaseFormDataId:  null,
    CompanyId:       companyId,
    DoctorId:        doctorId,
    FormName:        selectedData.selectedData[0].FormName,
    FormId:          selectedData.selectedData[0].FormId,
    TemplateName:    selectedData.selectedData[0].TemplateName,
    EntityLevel:     selectedData.selectedData[0].EntityLevel,
    FormType:        selectedData.selectedData[0].FormType,
    IsFormCompleted: selectedData.selectedData[0].IsFormCompleted,
    JsonData:        selectedData.selectedData[0].JsonData,
    CaseId:          caseId,
    UserId:          userId,
  });

  await fetchInstance(props.BaseUrl + "GenericForm/GetCaseFormData", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + TokenInfo.AccessToken,
    },
    body: requestBody,
  })
    .then((Response) => {
      if (Response.status === 401) { data = ""; return data; }
      return Response.json();
    })
    .then((result) => { data = result; return data; });

  return data;
}

export function GragIntakeSheetData(hippaAuthData) {
  let row = [];
  for (let i = 0; i < hippaAuthData?.notesdata.length; i++) {
    if (hippaAuthData?.notesdata[i].ApplicationValue) {
      for (
        let j = 0;
        j < hippaAuthData.notesdata[i].ApplicationValue.length;
        j++
      ) {
        let data = {};
        data.Name = hippaAuthData.notesdata[i].ApplicationValue[j].Name;
        data.Type = hippaAuthData.notesdata[i].ApplicationValue[j].Type;
        data.Value = hippaAuthData.notesdata[i].ApplicationValue[j].Value;
        data.isRender = hippaAuthData.notesdata[i].ApplicationValue[j].isRender;
        data.RenderKeyName = hippaAuthData.notesdata[i].RenderKeyName;
        row.push(data);
      }
    }
  }
  return row;
}

export async function CallSaveApiForIntakeSheet(
  props,
  collection,
  state,
  isChanged = false
) {
  let data = [];
  let SessionData = GetSessionData();
  let TokenInfo = GetTokenInfo();

  let companyId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.Account.ID
    : props.selectedRow.data.Account.ID;

  let doctorId = SessionData.Physician.ID;

  let caseId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.CaseID
    : props.selectedRow.data.CaseID;

  const requestBody = JSON.stringify({
    IsCopySign: props.copySignature,
    CaseId: caseId,
    CaseFormDataId: state.CaseFormDataId,
    UserId: SessionData.ID,
    IsFormCompleted: state.IsFormCompleted,
    FormId: props.intakeSheet.selectedData[0].FormId,
    EntityLevel: props.intakeSheet.selectedData[0].EntityLevel,
    TemplateName: props.intakeSheet.selectedData[0].TemplateName,
    CompanyId: companyId,
    DoctorId: doctorId,
    FormName: props.intakeSheet.selectedData[0].FormName,
    FormType: props.intakeSheet.selectedData[0].FormType,
    JsonData: JSON.stringify(collection),
    IsChanged: isChanged,
  });

  await fetchInstance(props.BaseUrl + "GenericForm/SaveCaseFormData", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + TokenInfo.AccessToken,

    },
    body: requestBody,
  })
    .then((Response) => {
      if (Response.status === 401) {
        data = "";
        return data;
      }
      return Response.json();
    })
    .then((result) => {
      data = result;
      return data;
    });

  return data;
}

export async function CallPrintApiForIntakeSheet(
  props,
  collection,
  state,
  SavePdfInDocMgr,
  isChanged = false
) {
  let data = [];
  let SessionData = GetSessionData();
  let TokenInfo = GetTokenInfo();

  let companyId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.Account.ID
    : props.selectedRow.data.Account.ID;

  let doctorId = SessionData.Physician.ID;

  let caseId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.CaseID
    : props.selectedRow.data.CaseID;

  const requestBody = JSON.stringify({
    IsCopySign: props.copySignature,
    CaseId: caseId,
    CaseFormDataId: state.CaseFormDataId,
    UserId: SessionData.ID,
    IsFormCompleted: state.IsFormCompleted,
    FormId: props.intakeSheet.selectedData[0].FormId,
    EntityLevel: props.intakeSheet.selectedData[0].EntityLevel,
    TemplateName: props.intakeSheet.selectedData[0].TemplateName,
    CompanyId: companyId,
    DoctorId: doctorId,
    FormName: props.intakeSheet.selectedData[0].FormName,
    FormType: props.intakeSheet.selectedData[0].FormType,
    JsonData: JSON.stringify(collection),
    IsChanged: isChanged,
    SavePdfInDocMgr: SavePdfInDocMgr,
  });

  await fetchInstance(props.BaseUrl + "GenericForm/PrintCaseData", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + TokenInfo.AccessToken,
    },
    body: requestBody,
  })
    .then((Response) => {
      if (Response.status === 401) {
        data = "";
        return data;
      }
      return Response.blob();
    })
    .then((result) => {
      data = result;
      return data;
    });

  return data;
}

export async function CallPrintApiForIntakeSheetFrontDesk(
  props,
  collection,
  state,
  providerId,
  SavePdfInDocMgr,
  isChanged = false
) {
  let data = [];
  let SessionData = GetSessionData();
  let TokenInfo = GetTokenInfo();

  let companyId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.Account.ID
    : props.selectedRow.data.Account.ID;

  let caseId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.CaseID
    : props.selectedRow.data.CaseID;

  const requestBody = JSON.stringify({
    IsCopySign: props.copySignature,
    CaseId: caseId,
    CaseFormDataId: state.CaseFormDataId,
    UserId: SessionData.ID,
    IsFormCompleted: state.IsFormCompleted,
    FormId: props.intakeSheet.selectedData[0].FormId,
    EntityLevel: props.intakeSheet.selectedData[0].EntityLevel,
    TemplateName: props.intakeSheet.selectedData[0].TemplateName,
    CompanyId: companyId,
    DoctorId: providerId,
    FormName: props.intakeSheet.selectedData[0].FormName,
    FormType: props.intakeSheet.selectedData[0].FormType,
    JsonData: JSON.stringify(collection),
    IsChanged: isChanged,
    SavePdfInDocMgr: SavePdfInDocMgr,
  });

  await fetchInstance(props.BaseUrl + "GenericForm/PrintCaseData", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + TokenInfo.AccessToken,
    },
    body: requestBody,
  })
    .then((Response) => {
      if (Response.status === 401) {
        data = "";
        return data;
      }
      return Response.blob();
    })
    .then((result) => {
      data = result;
      return data;
    });

  return data;
}

export async function CallSaveApiForIntakeSheetFrontDesk(
  props,
  collection,
  state,
  providerId,
  isChanged = false
) {
  let data = [];
  let SessionData = GetSessionData();
  let TokenInfo = GetTokenInfo();

  let companyId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.Account.ID
    : props.selectedRow.data.Account.ID;

  let caseId = props.selectedRow.searchResult
    ? props.selectedRow.searchResult.Patient.CaseID
    : props.selectedRow.data.CaseID;

  const requestBody = JSON.stringify({
    IsCopySign: props.copySignature,
    CaseId: caseId,
    CaseFormDataId: state.CaseFormDataId,
    UserId: SessionData.ID,
    IsFormCompleted: state.IsFormCompleted,
    FormId: props.intakeSheet.selectedData[0].FormId,
    EntityLevel: props.intakeSheet.selectedData[0].EntityLevel,
    TemplateName: props.intakeSheet.selectedData[0].TemplateName,
    CompanyId: companyId,
    DoctorId: providerId,
    FormName: props.intakeSheet.selectedData[0].FormName,
    FormType: props.intakeSheet.selectedData[0].FormType,
    JsonData: JSON.stringify(collection),
    officeId: providerId,
    IsChanged: isChanged,
  });

  await fetchInstance(props.BaseUrl + "GenericForm/SaveCaseFormData", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + TokenInfo.AccessToken,

    },
    body: requestBody,
  })
    .then((Response) => {
      if (Response.status === 401) {
        data = "";
        return data;
      }
      return Response.json();
    })
    .then((result) => {
      data = result;
      return data;
    });

  return data;
}

export const getFile = async (queryString) => {
    return (await DownloadWithCommon(CURRENT_CONFIG.COMMON_SERVICE_URL + `api/CommonServiceAPI/v1/Document/GetFile${queryString}`))
};

export function GetCommonServiceTokenInfo() {
  let Token = JSON.parse(sessionStorage.getItem(CommonServiceToken));
  return Token;
}

export const DownloadWithCommon = async (url, data) => {
    let CommonServiceToken = GetCommonServiceTokenInfo();
    return await fetchInstance(url, {
        method: "get",
        headers: {
            Accept: "blob",
            "Content-Type": "application/json",
            Authorization: "Bearer " + CommonServiceToken,
        },
        body: JSON.stringify(data)
    })
}


export const removeIntakeSheets = () => {
  removeSessionStorage(IntakeSheetSession.collectionOfhippaAuth)
  removeSessionStorage(IntakeSheetSession.collectionOfhippaDeclare)
  removeSessionStorage(IntakeSheetSession.collectionOfAOB)
  removeSessionStorage(IntakeSheetSession.collectionAcupunctureConsent)
  removeSessionStorage(IntakeSheetSession.CollectionOfAOBNJ)
  removeSessionStorage(IntakeSheetSession.collectionBotulinumConsent)
  removeSessionStorage(IntakeSheetSession.collectionChiropracticCareConsent)
  removeSessionStorage(IntakeSheetSession.collectionChiropracticTreatmentConsent)
  removeSessionStorage(IntakeSheetSession.CollectionOfDurablePowerOfAttorney)
  removeSessionStorage(IntakeSheetSession.collectionOfEPAT)
  removeSessionStorage(IntakeSheetSession.collectionOfNF2)
  removeSessionStorage(IntakeSheetSession.CollectionOfPatientConsent)
  removeSessionStorage(IntakeSheetSession.CollectionOfPatientDoctorContract)
  removeSessionStorage(IntakeSheetSession.collectionOfTriggerConsent)
  removeSessionStorage(IntakeSheetSession.collectionOfMedicalLien)
  removeSessionStorage(IntakeSheetSession.collectionOfMedicalVersionV2)
  removeSessionStorage(IntakeSheetSession.CollectionOfPregnancyConsent)
}